<template>
  <Modal @close="closeModalLocal" :wide="true" width="1400px" set-class="no-padding-mobile">
    <div slot="header">
      <div class="modal-header default-image" :style="(unit && (unit.image || (unit.pool && unit.pool.image) ) ) ? 'background-image:url(' + (unit && (unit.image || (unit.pool && unit.pool.image) ) ) + ')' : 'background-size: cover;'">
        <div class="heading" v-if="unit">
          <div class="heading-inner">
            {{ (unit.display_name || unit.description_title) }}
            <i v-if="unit.subtitle">{{unit.subtitle}}</i>
          </div>
        </div>
      </div>
    </div>

    <div class="notification center" v-if="$store.state.accomodationView && $store.state.accomodationView === 'images'">
      <p>Du visar nu våra boenden i ett specialläge där du kan ladda ner bilder.</p>
      <p><a href="#" @click.stop.prevent="goToNormal()">Gå till vanliga visningsläget</a></p>
    </div>

    <div class="modal-content" v-if="unit">
      <Loading :show="loading" />

      <div class="content-right max-tablet ">
        <AccomodationPeriodConfirm @gotprice="setPeriod" v-if="arrival" class="tighter" :unit="unit" :arrival="arrival" :departure="departure"></AccomodationPeriodConfirm>
        <button v-if="!$route.params.arrival" @click="openPriceList(unit)">Priser och tillgänglighet <icon name="arrow-white" :scale="1.4" /></button>

        <button v-if="$route.params.arrival && period && period.free" @click="chooseAccomodation({pool_lid: unit.pool_lid, unit_lid: unit.unit_lid, period: period, week: period.week, name: (unit.display_name || unit.description_title), capacity: unit.capacity, price: period.price})">Välj <icon name="cart-white" :scale="1.4" /></button>
        <!-- Fake button -->
        <button v-if="$route.params.arrival && !period" class="disabled">Välj <icon name="cart-white" :scale="1.4" /></button>

        <div v-if="period && !period.free" style="clear:both;"></div>
        <div class="alert" v-if="period && !period.free">
          <p>Den valda perioden är tyvärr upptagen. Leta gärna andra perioder genom att klicka på "Ändra datum" ovan.</p>
        </div>

        <div class="max-tablet save-mobile">
          <button v-if="!isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
            <icon name="heart" :scale="1.5" /> Spara och jämför
          </button>
          <button v-if="isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
            <icon name="heart-red" :scale="1.5" /> Sparad för jämförelse
          </button>
        </div>
      </div>
      <div class="content-left">
        <div class="tabs">
          <div :class="[
            'tab',
            activeTab === 'info' && 'active',
          ]" @click="setTab('info')">
            <icon name="info-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="info-white" :scale="1.5" class="icon icon-active"></icon>
            <div>
              <span class="min-tablet">Beskrivning</span>
              <span class="max-mobile">Info</span>
            </div>
          </div>
          <div :class="[
            'tab',
            activeTab === 'images' && 'active',
          ]" @click="setTab('images')">
            <icon name="img-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="img-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Bilder</div>
          </div>
          <div :class="[
            'tab',
            activeTab === 'map' && 'active',
          ]" @click="setTab('map')" v-if="!(unit && unit.pool) || !unit.pool.hide_map">
            <icon name="map-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="map-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Karta</div>
          </div>
          <div :class="[
            'tab',
            activeTab === 'video' && 'active',
          ]" @click="setTab('video')" v-if="(unit && unit.pool) && unit.pool.video">
            <icon name="play-blue" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="play-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Film</div>
          </div>
          <div :class="[
            'fact',
            'tab',
            activeTab === 'fact' && 'active',
          ]" @click="setTab('fact')">
            <icon name="facts-unit" :scale="1.5" class="icon icon-inactive"></icon>
            <icon name="facts-unit-white" :scale="1.5" class="icon icon-active"></icon>
            <div>Fakta</div>
          </div>
        </div>
        <div v-if="activeTab === 'info'" class="info" v-html="nl2br(unit.description_full)">
        </div>
        <div v-if="activeTab === 'images'" class="images">
          <Slideshow :images="unit.images" />
        </div>
        <div v-if="activeTab === 'video'" class="video">
          <Vimeo :url="unit.pool.video" />
        </div>
        <div v-if="activeTab === 'fact'" class="fact min-mobile">
          <div v-if="!SITE_CONFIG.settings.SettingLockTypes.active && unit.direct_incheck" class="flex marked-usp">
            <div class="icon">
              <icon name="direktincheck" :scale="3" />
            </div>
            <div class="information">
              <p class="title">Digital incheckning</p>
              <p class="information-text">Åk direkt till boendet – kod till dörren får du via SMS.</p>
            </div>
          </div>
          <div v-if="SITE_CONFIG.settings.SettingLockTypes.active && unit.lock_type_id" class="flex marked-usp">
            <div class="icon">
              <icon name="direktincheck" :scale="3" />
            </div>
            <div class="information">
              <p class="title">{{ SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].title }}</p>
              <p class="information-text">{{ SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].description }}</p>
            </div>
          </div>
          <div v-if="unit.dishwasher_usp" class="flex marked-usp">
            <div class="icon">
              <icon name="dishwasher-filled" :scale="3" />
            </div>
            <div class="information">
              <p class="title">{{ unit.dishwasher_usp_title }}</p>
              <p class="information-text">{{ unit.dishwasher_usp_text }}</p>
            </div>
          </div>

          <UnitFacts :unit="unit"></UnitFacts>
        </div>
      </div>
      <div class="content-right facts-desktop">
        <AccomodationPeriodConfirm @gotprice="setPeriod" v-if="arrival" class="tighter" :unit="unit" :arrival="arrival" :departure="departure"></AccomodationPeriodConfirm>
        <button v-if="!$route.params.arrival" @click="openPriceList(unit)">Priser och tillgänglighet <icon name="arrow-white" :scale="1.4" /></button>

        <button v-if="$route.params.arrival && period && period.free" @click="chooseAccomodation({pool_lid: unit.pool_lid, unit_lid: unit.unit_lid, period: period, week: period.week, name: (unit.display_name || unit.description_title), capacity: unit.capacity, price: period.price})">Välj <icon name="cart-white" :scale="1.4" /></button>
        <!-- Fake button -->
        <button v-if="$route.params.arrival && !period" class="disabled">Välj <icon name="cart-white" :scale="1.4" /></button>

        <div v-if="period && !period.free" style="clear:both;"></div>
        <div class="alert" v-if="period && !period.free">
          <p>Den valda perioden är tyvärr upptagen. Leta gärna andra perioder genom att klicka på "Ändra datum" ovan.</p>
        </div>

        <button v-if="!isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
          <icon name="heart" :scale="1.5" /> Spara och jämför
        </button>
        <button v-if="isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
          <icon name="heart-red" :scale="1.5" /> Sparad för jämförelse
        </button>

        <div v-if="!SITE_CONFIG.settings.SettingLockTypes.active && unit.direct_incheck" class="flex marked-usp">
          <div class="icon">
            <icon name="direktincheck" :scale="3" />
          </div>
          <div class="information">
            <p class="title">Digital incheckning</p>
            <p class="information-text">Åk direkt till boendet – kod till dörren får du via SMS.</p>
          </div>
        </div>
        <div v-if="SITE_CONFIG.settings.SettingLockTypes.active && unit.lock_type_id" class="flex marked-usp">
          <div class="icon">
            <icon name="direktincheck" :scale="3" />
          </div>
          <div class="information">
            <p class="title">{{ SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].title }}</p>
            <p class="information-text">{{ SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].description }}</p>
          </div>
        </div>
        <div v-if="unit.dishwasher_usp" class="flex marked-usp">
          <div class="icon">
            <icon name="dishwasher-filled" :scale="3" />
          </div>
          <div class="information">
            <p class="title">{{ unit.dishwasher_usp_title }}</p>
            <p class="information-text">{{ unit.dishwasher_usp_text }}</p>
          </div>
        </div>
        <UnitFacts :unit="unit"></UnitFacts>
      </div>
    </div>
    <div class="max-tablet save-mobile" v-if="unit">
      <button v-if="!isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
        <icon name="heart" :scale="1.5" /> Spara och jämför
      </button>
      <button v-if="isFavorite(unit.id)" class="white small border" @click="toggleFavorite(unit.id)">
        <icon name="heart-red" :scale="1.5" /> Sparad för jämförelse
      </button>
    </div>
    <pre v-if="false">{{ unit }}</pre>
  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import UnitFacts from '@/components/parts/Accomodation/UnitFacts';
import API from '@/classes/API';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';
import Vimeo from '@/components/components/Vimeo';
import Slideshow from '@/components/components/Slideshow';
import Loading from '@/components/components/Loading';

import accomodationIndex from '@/mixins/accomodationIndex';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    UnitFacts,
    AccomodationPeriodConfirm,
    Vimeo,
    Loading,
    Slideshow,
  },
  mixins: [accomodationIndex],
  data() {
    return {
      activeTab: 'info',
      unit: null,
      loaded: false,
      period: null,
      arrival: null,
      departure: null,
      loading: false,
    };
  },
  async mounted() {
    if (this.$route.query.no === undefined || this.$route.query.no === '') {
      const query = this.$route.query;
      query.no = this.currentRealAccomodationIndex;

      setTimeout(() => {
        this.$router.replace({
          name: this.$route.name,
          query,
        });
      }, 1);
    }

    this.loading = true;
    let data = {};

    const query = `?arrival=${this.$route.params.arrival}&departure=${this.$route.params.departure}`;

    if (this.$route.params.slug) {
      data = await API.get(`/units/${this.$route.params.slug}/info${query}`);
    } else {
      data = await API.get(`/units/${this.$route.params.poolId}/${this.$route.params.unitId}/info${query}`);
    }

    this.loaded = true;
    this.unit = data.data;

    this.arrival = this.$route.params.arrival;
    this.departure = this.$route.params.departure;
    this.loading = false;

    if (this.$route.meta.view && this.$route.meta.view === 'images') {
      this.activeTab = 'images';
      this.$store.state.accomodationView = 'images';
    }

    window.trackViewItem({
      title: this.unit.description_title,
      lines: [{
        id: this.unit.unit_code || this.unit.name_corrected,
        title: this.unit.description_title,
        category: 'accomodation',
        category2: (this.unit && this.unit.pool) ? this.unit.pool.name : '',
        quantity: 1,
        price: this.unit.lowest_price,
      }],
    });
  },
  computed: {
    ...mapGetters([
      'confirmedAccomodations',
      'favoriteAccommodations',
    ]),
  },
  methods: {
    setPeriod(period) {
      if (period.available) {
        this.period = period;
      } else {
        this.period = null;
      }
    },
    closeModalLocal() {
      if (this.$route.query.flow) {
        this.$router.push({ path: `/${this.$route.query.flow}` });
      } else {
        this.$router.go(-1);
      }
    },
    setTab(tab) {
      if (tab === 'map') {
        this.openModal([`MapModal${this.SITE_CONFIG.site}`, {
          locationId: (this.unit.facility ? this.unit.facility.id : null),
          areaId: (this.unit.pool ? this.unit.pool.id : null),
          map_link: this.unit.pool.map_link,
        }]);
      } else {
        this.activeTab = tab;
      }
    },
    openPriceList(unit) {
      const url = encodeURIComponent(`boenden/info/${unit.slug}`);
      this.$router.push({ path: `/boenden/pris/${unit.slug}?flow=${url}` });
    },
    isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    toggleFavorite(unitId) {
      const index = this.favoriteAccommodations.indexOf(unitId);
      if (index > -1) {
        this.removeFavorite(index);
      } else {
        const $this = this;
        const favoriteCount = this.favoriteAccommodations.length;
        if (favoriteCount >= 3) {
          this.openModal(['GeneralModal', {
            title: 'Max 3 favoritboenden',
            content: '<p>Du kan endast spara 3 favoritboenden.</p>',
            buttons: [
              {
                title: 'Okej',
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              },
            ],
          }]);
        } else {
          this.addFavorite(unitId);
          if (favoriteCount === 2) {
            this.openModal(['GeneralModal', {
              title: '3 favoriter',
              content: 'Du har nu 3 favoriter tillagda för jämförelse, du kan inte lägga till fler. Vill du jämföra dem nu?',
              buttons: [{
                title: 'Ja, jämför',
                class: '',
                click: () => {
                  this.$router.push({ name: 'compare-accomodations' });
                },
              }, {
                title: 'Nej, fortsätt leta',
                class: 'white border',
                click: () => {
                  this.closeModal();
                },
              }],
            }]);
          }
        }
      }
    },
    ...mapMutations([
      'closeModal',
      'openModal',
      'accomodationPeriodPick',
      'accomodationPeriodPick',
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
      'addFavorite',
      'removeFavorite',
    ]),
    didChooseAccomodation(payload) {
      const p = payload;
      p.unit = this.unit;
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      let no = this.currentRealAccomodationIndex;
      if (no === -1) {
        no = this.$store.state.cart.accomodations
              .filter(accomodation => accomodation.confirmed).length;
      }
      p.no = no;

      console.log(no);
      console.log(p);

      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;

      this.pickAccomodation(p);

      this.$router.push({ name: 'confirm-accomodation', query: { d: new Date().getTime(), no } });
    },
    chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    nl2br(input) {
      /* eslint-disable */
      var breakTag = '<br>';
      return (input.toString()).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
    },
    goToNormal() {
      this.$store.state.accomodationView = '';
      this.closeModalLocal();
    },
  },
};
</script>

<style scoped lang="stylus">
  @import '~@/global.styl'

  .notification
    info-box()
    margin 0 auto
    margin-top: 30px
    margin-bottom: 0
    max-width container-width

  .disabled
    disabled()

  .alert
    border-radius 2px
    padding 15px 27px
    margin-top: 0
    margin-bottom: 20px
    background-color: #fff4d7
    border: 1px solid #ffe67d
    p
      margin-bottom: 0

  .modal-content
    display flex
    padding 30px 0
    +max-tablet()
      padding 15px 0
      flex-wrap: wrap

  .content-left
    border-right 1px solid silver-light
    flex none
    width 50%
    box-sizing border-box
    padding 10px 50px
    +max-tablet()
      width 100%
      padding-left 0
      padding-right 0

  .content-right
    border-right 1px solid silver-light
    flex none
    width 50%
    box-sizing border-box
    padding 10px 50px
    &.facts-desktop
      display: none
      +min-xl-tablet()
        display: inline-block
    .period-wrapper
      margin-top: 10px
    button
      margin-right: 20px
      margin-bottom: 15px
      min-width: 150px
      +max-tablet()
        width: 80%
        margin-top: 10px
        max-width: 300px
        font-size: 12px
      +max-mobile()
        min-width auto
        margin-right: 0px
        margin-bottom: 0px
    +max-tablet()
      width 100%
      padding-left 0
      padding-right 0
      text-align: center
    .image-holder
      display inline-block
      float left
      margin-right 10px
      img
        width 50px

  .save-mobile
    margin-left: 15px
    +max-mobile()
      margin-left: 0px

    button
      margin-bottom 25px
      padding-left 5%
      padding-right 5%
      margin-right 2%
      +max-tablet()
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 5px



    .small
      position: relative;
      top: 9px;

  .tabs
    display flex
    align-items stretch
    margin-bottom space-3

  .tab
    background pale-sky
    flex 1 1 0
    border-right 2px solid #fff
    font-size 12px
    padding space-1
    font-weight bold
    text-transform uppercase
    text-align center
    cursor pointer
    +max-tablet()
      font-size: 10px
      padding 5px
    .icon
      margin space-half 0
      color deep-sea-blue
      &.icon-inactive
        display inline-block
      &.icon-active
        display none
    &:hover:not(.active)
      fill-shadow(light-blue-gray, .5)
      display inline-block
    &.active
      background deep-sea-blue
      color white
      position relative
      .icon
        color inherit
        &.icon-inactive
          display none
        &.icon-active
          display inline-block
      &:after
        color deep-sea-blue
        content ''
        display block
        position absolute
        bottom 0
        left 50%
        margin-left -10px
        margin-bottom -10px
        border-top 10px solid currentColor
        border-right 10px solid transparent
        border-bottom 0
        border-left 10px solid transparent
    &:first-child
      border-top-left-radius 3px
      border-bottom-left-radius 3px
      +max-tablet()
        border-top-left-radius 0px
        border-bottom-left-radius 0px
    &:last-child
      border-top-right-radius 3px
      border-bottom-right-radius 3px
      border-right none
      +max-tablet()
        border-top-left-radius 0px
        border-bottom-left-radius 0px

  .modal-header
    background silver
    // height 460px
    display flex
    justify-content center
    align-items flex-end
    margin -space-2 -space-2 0 -space-2
    padding-top: 55.4%
    position relative
    +max-mobile()
      margin 0
    // +max-tablet()
      // height 210px
      // margin-top 0
      // margin: 0px
  .heading
    position: absolute;
    bottom: 0;
    top: auto;
    left: 0;
    right: auto;
    display: flex;
    justify-content: center;
    width: 100%;
    united-heavy()
    font-size 30px
    +max-tablet()
      font-size 19px
    text-transform uppercase
    centered()
    .heading-inner
      background white
      padding 30px 40px 20px 40px
      border-radius 4px 4px 0 0
      margin 0 40px
      +max-tablet()
        padding 9px 13px
        margin 0 13px
    i
      font-style normal
      font-weight normal
      display block
      color greyish-brown
      margin-top 9px
      font-size 15px
      +max-tablet()
        margin-top 4px
        font-size 12px
      line-height 1em
      font-family Interstate
      letter-spacing 0em
      text-transform none

  .info
    font-size 15px
    line-height 1.4
    p
      line-height inherit
      margin-bottom 1.4em

  +min-xl-tablet()
    .tab.fact
      display none

  +max-tablet()
    .info,
    .images,
    .video,
    .fact
      padding-left padding-mobile
      padding-right padding-mobile
      width 100%

  .preamble
    font-size 17px
    font-weight bold

  .bold
    font-weight bold

  .modal-header
    background-position center
    background-size cover

  .marked-usp
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px 7px 7px 11px;
    margin-bottom: 12px;
    gap: 20px;
    background: #F3BD60;
    border-radius: 4px;

    .information
      margin-left: -10px;

    .title
      font-family: 'Barlow';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 16px;
      color: #000000;
      margin-bottom: 5px;

    .information-text
      font-family: 'Barlow';
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 15px;
      color: #000000;
      margin-bottom: 0;

</style>


// WEBPACK FOOTER //
// AccomodationsPageInfo.vue?41179556